<template>
  <div class="wrapper dashboard-wrapper whopperco-wrapper">
    <side-bar>
      <template slot="links">
        <div>
          <sidebar-item class="mb-4" :link="{ name: 'Dashboard',     icon: 'dashbaordicon menu-icons',    path: '/whopperco/dashboard'    }" />
          <sidebar-item class="mb-4" :link="{ name: 'My Courses',    icon: 'menu-icons coursesicon',      path: '/whopperco/courses'      }" />
          <sidebar-item class="mb-4" :link="{ name: 'Certificates',  icon: 'menu-icons certificatesicon', path: '/whopperco/certificates' }" />
          <sidebar-item class="mb-4" :link="{ name: 'Notifications', icon: 'menu-icons notification-ico', path: '/whopperco/notifications'}" />
          <sidebar-item class="mb-4" :link="{ name: 'Documents',     icon: 'menu-icons documents',        path: '/whopperco/documents'    }" />
          <sidebar-item class="mb-4" :link="{ name: 'Onboarding',    icon: 'menu-icons user-icon',        path: '/whopperco/onboarding'   }" />
          <sidebar-item class="mb-4" :link="{ name: 'Tutorial Video',icon: 'menu-icons TutorialVideosicon', path: '/whopperco/tutorial'   }" />
          <sidebar-item class="mb-4 d-md-none" @click.native="signOut" :link="{ name: 'Logout', icon: 'menu-icons logout-icon', path: '/login' }" />
        </div>
      </template>
    </side-bar>

    <div class="main-content px-4">
      <nav class="whopperco-navbar">
        <div class="whopperco-search">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M15.0258 13.8475L18.595 17.4159L17.4158 18.595L13.8475 15.0259C12.5198 16.0902 10.8683 16.6691 9.16667 16.6667C5.02667 16.6667 1.66667 13.3067 1.66667 9.16669C1.66667 5.02669 5.02667 1.66669 9.16667 1.66669C13.3067 1.66669 16.6667 5.02669 16.6667 9.16669C16.6691 10.8684 16.0902 12.5198 15.0258 13.8475Z" fill="#9ca3af"/>
          </svg>
          <input type="text" placeholder="Search courses, certificates, documents…" />
        </div>
        <div class="whopperco-navbar-right">
          <button class="whopperco-icon-btn" aria-label="Notifications">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#502314" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 10-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
            </svg>
            <span class="whopperco-icon-dot"></span>
          </button>
          <div class="whopperco-user">
            <span class="whopperco-user-name">Sabrina Cruz</span>
            <span class="whopperco-user-role">Employee · Store BK-2241</span>
          </div>
          <span class="whopperco-avatar">SC</span>
        </div>
      </nav>

      <div class="content">
        <div class="dashbaord-row-card">
          <div class="row">
            <div class="col-xl-12">
              <div class="dash-header mb-4">
                <h2 class="text-default m-0 d-flex">Onboarding <img src="/signup-img/fire.svg" alt="" /></h2>
                <p class="text-secondary">Three quick steps to finish setting up your Whopperco account.</p>
              </div>
            </div>
          </div>

          <!-- Progress strip — matches Course Overview pattern -->
          <div class="card top-cardheader">
            <div class="card-header border-bottom px-0 px-sm-4 py-3 d-flex justify-content-between align-items-center">
              <h5 class="font-weight-normal text-default m-0">Your progress</h5>
              <span class="onboarding-progress-pill">{{ completedCount }} of {{ totalSteps }} complete</span>
            </div>
            <div class="row m-0">
              <div class="col-xl-4 col-md-12 p-0" v-for="step in topSteps" :key="step.id">
                <div class="dash-card-box emp-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
                  <div class="card-value-box">
                    <div class="card-icon-img onboarding-step-icon" :class="{ done: step.complete }">
                      <span v-if="step.complete">✓</span>
                      <span v-else>{{ step.id }}</span>
                    </div>
                    <div class="card-left flex-grow-1 pl-3">
                      <h5 class="font-weight-normal m-0">{{ step.title }}</h5>
                      <span class="text-secondary small">{{ step.complete ? 'Complete' : step.due }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Two-column layout: forms + sidebar -->
        <div class="row mt-4">
          <div class="col-lg-8">
            <!-- Step 1: Banking -->
            <div class="card no-border-card mb-3 onboarding-section-card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-1">
                  <span class="step-number" :class="{ done: !!files.banking }">{{ files.banking ? '✓' : '1' }}</span>
                  <h3 class="mb-0 ml-3 onboarding-section-title">Direct deposit details</h3>
                </div>
                <p class="text-secondary onboarding-section-desc">Upload a voided check or bank letter so payroll can route your wages.</p>
                <label class="onboarding-dropzone" @dragover.prevent @drop.prevent="onDrop($event, 'banking')">
                  <span class="onboarding-dropzone-icon">📎</span>
                  <span v-if="!files.banking">
                    <strong>Drag a file here</strong> or click to browse · PDF or image, up to 10 MB
                  </span>
                  <span v-else>
                    <strong>{{ files.banking }}</strong> · ✓ Ready · <a href="#" @click.prevent.stop="files.banking = null">remove</a>
                  </span>
                  <input type="file" accept="image/*,application/pdf" hidden @change="onFile($event, 'banking')" />
                </label>
              </div>
            </div>

            <!-- Step 2: Government ID -->
            <div class="card no-border-card mb-3 onboarding-section-card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-1">
                  <span class="step-number" :class="{ done: !!files.id }">{{ files.id ? '✓' : '2' }}</span>
                  <h3 class="mb-0 ml-3 onboarding-section-title">Government-issued ID</h3>
                </div>
                <p class="text-secondary onboarding-section-desc">Driver's license, state ID, or passport. Used for I-9 verification.</p>
                <label class="onboarding-dropzone" @dragover.prevent @drop.prevent="onDrop($event, 'id')">
                  <span class="onboarding-dropzone-icon">🪪</span>
                  <span v-if="!files.id">
                    <strong>Drag a file here</strong> or click to browse · Clear photo of the front
                  </span>
                  <span v-else>
                    <strong>{{ files.id }}</strong> · ✓ Ready · <a href="#" @click.prevent.stop="files.id = null">remove</a>
                  </span>
                  <input type="file" accept="image/*,application/pdf" hidden @change="onFile($event, 'id')" />
                </label>
              </div>
            </div>

            <!-- Step 3: Signature -->
            <div class="card no-border-card mb-3 onboarding-section-card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-1">
                  <span class="step-number" :class="{ done: signed }">{{ signed ? '✓' : '3' }}</span>
                  <h3 class="mb-0 ml-3 onboarding-section-title">Sign your franchise agreement</h3>
                </div>
                <p class="text-secondary onboarding-section-desc">Use your finger or trackpad. We'll countersign and email you a copy.</p>
                <canvas
                  ref="sig"
                  class="onboarding-signature-pad"
                  @mousedown="startDraw" @mousemove="draw" @mouseup="endDraw" @mouseleave="endDraw"
                  @touchstart.prevent="startDrawTouch" @touchmove.prevent="drawTouch" @touchend.prevent="endDraw"
                ></canvas>
                <div class="d-flex mt-2" style="gap: 8px;">
                  <button type="button" class="btn btn-sm btn-outline-secondary" @click="clearSig">Clear</button>
                  <button type="button" class="btn btn-sm btn-primary" @click="confirmSig">
                    {{ signed ? 'Signed ✓' : 'Confirm signature' }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Submit row -->
            <div class="card no-border-card">
              <div class="card-body d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <p class="mb-1"><strong>Ready to submit?</strong></p>
                  <p class="text-secondary small mb-0">
                    Once you submit, your franchise GM will be notified and your courses unlock.
                  </p>
                </div>
                <button type="button" class="btn btn-primary px-4" @click="submitAll">
                  Submit onboarding →
                </button>
              </div>
              <div v-if="submitted" class="alert alert-success m-3" role="alert">
                <strong>Submitted.</strong> Your GM has been notified — taking you to your training dashboard…
              </div>
            </div>
          </div>

          <!-- Right rail: pending tasks + help -->
          <div class="col-lg-4">
            <div class="card no-border-card mb-4">
              <div class="card-header">
                <h5 class="mb-0">Pending tasks</h5>
                <p class="text-secondary small mb-0 mt-1">Auto-updates as you complete each step.</p>
              </div>
              <div class="card-body">
                <ul class="onboarding-task-list">
                  <li
                    v-for="t in tasks"
                    :key="t.id"
                    class="onboarding-task-item"
                    :class="{ complete: t.complete }"
                  >
                    <span class="onboarding-task-icon">{{ t.complete ? '✓' : t.id }}</span>
                    <div class="flex-grow-1">
                      <p class="mb-0"><strong>{{ t.title }}</strong></p>
                      <p class="text-secondary small mb-0">{{ t.complete ? 'Completed' : t.due }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="card no-border-card">
              <div class="card-body">
                <p class="mb-1"><strong>Need help?</strong></p>
                <p class="text-secondary small mb-0">
                  Your franchise GM can help with any step. Or email
                  <a href="mailto:support@whopperco.com">support@whopperco.com</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhopperOnboarding',
  data() {
    return {
      files: { banking: null, id: null },
      signed: false,
      drawing: false,
      lastPos: null,
      submitted: false,
    };
  },
  computed: {
    tasks() {
      return [
        { id: 1, title: 'Upload direct deposit details', due: 'Due before first payroll cycle', complete: !!this.files.banking },
        { id: 2, title: 'Upload government ID for I-9', due: 'Due within 3 business days',     complete: !!this.files.id },
        { id: 3, title: 'Sign franchise agreement',     due: 'Due today',                       complete: this.signed },
        { id: 4, title: 'Complete BK food handler course', due: 'Assigned by GM',              complete: false },
        { id: 5, title: 'Watch workplace safety video',  due: 'Within first week',              complete: false },
      ];
    },
    topSteps() {
      return [
        { id: 1, title: 'Direct deposit',       due: 'Before first payroll',   complete: !!this.files.banking },
        { id: 2, title: 'Government ID',        due: 'Within 3 business days', complete: !!this.files.id },
        { id: 3, title: 'Franchise agreement',  due: 'Today',                  complete: this.signed },
      ];
    },
    completedCount() { return this.tasks.filter(t => t.complete).length; },
    totalSteps()     { return this.tasks.length; },
  },
  methods: {
    onFile(e, key) { const f = e.target.files && e.target.files[0]; if (f) this.files[key] = f.name; },
    onDrop(e, key) { const f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) this.files[key] = f.name; },
    canvasPos(e) {
      const c = this.$refs.sig; const r = c.getBoundingClientRect();
      const t = e.touches && e.touches[0];
      return { x: (t ? t.clientX : e.clientX) - r.left, y: (t ? t.clientY : e.clientY) - r.top };
    },
    startDraw(e) { this.drawing = true; this.lastPos = this.canvasPos(e); },
    startDrawTouch(e) { this.startDraw(e); },
    draw(e) {
      if (!this.drawing) return;
      const c = this.$refs.sig;
      const ctx = c.getContext('2d');
      if (c.width !== c.clientWidth) { c.width = c.clientWidth; c.height = c.clientHeight; }
      const p = this.canvasPos(e);
      ctx.strokeStyle = '#1e1e1e'; ctx.lineWidth = 2.5; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(this.lastPos.x, this.lastPos.y); ctx.lineTo(p.x, p.y); ctx.stroke();
      this.lastPos = p;
    },
    drawTouch(e) { this.draw(e); },
    endDraw() { this.drawing = false; },
    clearSig() {
      const c = this.$refs.sig; const ctx = c.getContext('2d');
      ctx.clearRect(0, 0, c.width, c.height); this.signed = false;
    },
    confirmSig() { this.signed = true; },
    submitAll() {
      this.submitted = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => this.$router.push('/whopperco/dashboard'), 1300);
    },
    signOut() { this.$router.push('/login'); },
  },
};
</script>

<style scoped>
.whopperco-wrapper { font-family: "Inter", "Nunito", sans-serif; }

/* Top navbar — same pattern as the dashboard */
.whopperco-navbar { display: flex; align-items: center; gap: 16px; padding: 18px 0 22px; margin-bottom: 8px; }
.whopperco-search { flex: 1; max-width: 540px; position: relative; display: flex; align-items: center; gap: 10px; background: #fff; border: 1px solid #e5e7eb; border-radius: 999px; padding: 8px 20px; transition: border-color 0.2s, box-shadow 0.2s; }
.whopperco-search:focus-within { border-color: #ea2628; box-shadow: 0 0 0 4px rgba(234, 38, 40, 0.08); }
.whopperco-search input { border: 0; background: transparent; outline: 0; flex: 1; font-size: 14px; color: #1e1e1e; padding: 4px 0; }
.whopperco-search input::placeholder { color: #9ca3af; }
.whopperco-navbar-right { margin-left: auto; display: flex; align-items: center; gap: 14px; }
.whopperco-icon-btn { background: #fff; border: 1px solid #e5e7eb; width: 38px; height: 38px; border-radius: 999px; display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative; transition: border-color 0.15s; }
.whopperco-icon-btn:hover { border-color: #ea2628; }
.whopperco-icon-dot { position: absolute; top: 6px; right: 6px; width: 8px; height: 8px; border-radius: 999px; background: #ea2628; border: 2px solid #fff; }
.whopperco-user { display: flex; flex-direction: column; text-align: right; line-height: 1.15; }
.whopperco-user-name { font-size: 14px; font-weight: 700; color: #1e1e1e; }
.whopperco-user-role { font-size: 11px; color: #6b7280; }
.whopperco-avatar { width: 38px; height: 38px; border-radius: 999px; background: linear-gradient(135deg, #ea2628 0%, #e48e39 100%); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 13px; font-weight: 800; letter-spacing: 0.5px; }
@media (max-width: 768px) { .whopperco-navbar { flex-wrap: wrap; padding: 12px 0 16px; } .whopperco-user { display: none; } .whopperco-search { max-width: 100%; width: 100%; } }

.onboarding-progress-pill {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  color: #fff;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.onboarding-step-icon {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
}

.onboarding-step-icon.done {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  color: #fff;
}

.step-number {
  width: 26px; height: 26px; border-radius: 999px;
  background: #f3f4f6; color: #6b7280;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 800;
}

.step-number.done {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  color: #fff;
}

.onboarding-dropzone {
  display: block;
  border: 2px dashed #e5e7eb;
  background: #fafafa;
  border-radius: 10px;
  padding: 18px 16px;
  text-align: center;
  cursor: pointer;
  margin: 0;
  transition: background 0.2s, border-color 0.2s;
}

.onboarding-dropzone:hover {
  background: #fff7ed;
  border-color: #e48e39;
}

.onboarding-dropzone-icon {
  font-size: 24px;
  display: block;
  margin-bottom: 4px;
}

.onboarding-signature-pad {
  width: 100%;
  height: 130px;
  background: #fafafa;
  border: 2px dashed #e5e7eb;
  border-radius: 10px;
  cursor: crosshair;
  display: block;
}

.onboarding-section-card .card-body { padding: 14px 18px; }
.onboarding-section-title { font-size: 15px; font-weight: 700; }
.onboarding-section-desc { font-size: 12px; margin: 0 0 10px; padding-left: 38px; }

.onboarding-task-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.onboarding-task-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
}

.onboarding-task-item:last-child {
  border-bottom: 0;
}

.onboarding-task-item.complete .onboarding-task-icon {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
}

.onboarding-task-icon {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: linear-gradient(135deg, #e48e39 0%, #ea2628 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  flex-shrink: 0;
}
</style>
